<div class="dashboard grid">
    @for (widget of widgetList; track $index) {
        @if (canShow(widget)) {
            <div class="col-12 sm:col-4">
                <ndc-dynamic [ndcDynamicComponent]="widgetLoader.getWidget(widget.Type)" [ndcDynamicInputs]="getWidgetInput(widget)"></ndc-dynamic>
            </div>
        }
    }
</div>
